// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EmailUnsubscribeDefaultResponse {
    static getAttributeTypeMap() {
        return EmailUnsubscribeDefaultResponse.attributeTypeMap;
    }
}
EmailUnsubscribeDefaultResponse.discriminator = undefined;
EmailUnsubscribeDefaultResponse.additionalProperties = false;
EmailUnsubscribeDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "boolean"
    },
];
//# sourceMappingURL=emailUnsubscribeDefaultResponse.js.map